import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Switch, Typography } from '@lyearn/ui';

import { PraiseVisibilityProps } from './types';

const PraiseVisibility: React.FC<PraiseVisibilityProps> = (props) => {
  const { value, onChange } = props;
  const { t } = useTranslation();

  const _onChange = useCallback(
    (_: any, value: boolean) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <Stack className="-mt-8 ms-8" justifyContent="between">
      <Typography variant="body-short-01">{t('Praises:Form.VisibleToEveryone')}</Typography>
      <Switch checked={value} name="visibleToEveryone" onChange={_onChange} />
    </Stack>
  );
};

export default PraiseVisibility;
